import { Injectable, inject } from "@angular/core";

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { GetNoteObjectViewModel, INote } from "@tylertech/tyler-api-types";

import { NotesDialogComponent, NotesDialogData } from "./dialog";

@Injectable()
export class NotesDialogService
{
    private readonly matDialog = inject(MatDialog);


    show(
        settings: GetNoteObjectViewModel,
        isAdd: boolean,
        viewOnly: boolean,
        newParentItem: boolean = false,
        passedNotes?: INote[],
        hideSubject: boolean = false,
        singleNote: boolean = false
    ): Promise<INote[]>
    {
        const dialogConfig: MatDialogConfig<NotesDialogData> = {
            width: "50vw",
            data: {
                hideSubject,
                isAdd,
                newParentItem,
                passedNotes,
                settings,
                singleNote,
                viewOnly
            }
        };
        const dialogRef = this.matDialog.open<NotesDialogComponent>(
            NotesDialogComponent,
            dialogConfig);

        return dialogRef.afterClosed()
            .toPromise();
    }
}
